/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var dump = function dump(value) {
  return JSON.stringify(value, null, 2);
};

export { dump };
//# sourceMappingURL=dump.js.map
